var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:{
    step: true,
    active: _vm.active,
    answered: _vm.answer,
    notanswered: !_vm.answer && _vm.noanswer
  },attrs:{"to":{ path: _vm.path }}},[_c('div',{staticClass:"data"},[(_vm.index >= 0)?_c('em',{staticClass:"num"},[_vm._v(_vm._s(_vm.index + 1))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"answer"},[(_vm.answer)?_c('strong',[_vm._v(_vm._s(_vm.formattedAnswer)+" "+_vm._s(_vm.unit))]):(_vm.noanswer)?_c('strong',[_vm._v("Nincs válasz")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }